var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { style: _vm.dependenciesComponentsStyleList }, [
    _c("span", {
      staticClass: "ui-icon-circle-close error--text mx-auto mb-3 d-block",
      style: _vm.canceledIconStyleList,
    }),
    _vm._v(" "),
    _c("div", { staticClass: "text-h5 text--text mb-4 text-center" }, [
      _vm._v("\n    Платёж не прошёл\n  "),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "b-button b-button_blue",
        class: _vm.buttonDeviceClassList,
        on: { click: _vm.handleButtonClickOnce },
      },
      [
        _c("span", { staticClass: "text-button" }, [
          _vm._v("\n      Повторить\n    "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "text-body-1 text-secondary--text mb-6 text-center" },
      [
        _vm._v("\n    Деньги с вашей карты не списаны.\n    "),
        _c("br"),
        _vm._v("\n    Попробуйте оплатить ещё раз.\n  "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }